"use client";

import { EmptyState } from "@/components/feedback";
import { MicrositeListFetchError } from "@/components/shared/MicrositeListFetchError";
import { Text } from "@/components/ui";
import { useTenantContentSettingsGet } from "@/features/profile-settings/hooks/useTenantContentSettingsGet";
import { ContentSettingsText } from "@/lib/utils/content-settings/ContentSettingsText";
import { useTenantData } from "@/hooks";
import { getTenantDisplayName } from "@/lib/utils/tenant";

interface TeachersPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const TeachersPageError = ({
  onRetry,
  isRetrying = false,
}: TeachersPageErrorProps) => {
  return (
    <MicrositeListFetchError
      onRetry={onRetry}
      isRetrying={isRetrying}
      testId="teachers-page-retry-button"
    />
  );
};

export const TeachersPageEmpty = () => {
  const { tenantId, tenantData } = useTenantData();
  const { data: contentSettings } = useTenantContentSettingsGet(
    { tenantId },
    { enabled: !!tenantId },
  );

  return (
    <EmptyState
      title={contentSettings.teachersEmptyTitle}
      message={
        <ContentSettingsText
          variant="secondary"
          fontSize="sm"
          textAlign="center"
          studioName={getTenantDisplayName(tenantData)}
          tenantEmail={tenantData?.email}
        >
          {contentSettings.teachersEmptyDescription}
        </ContentSettingsText>
      }
    />
  );
};

export const TeachersPageNoResults = ({
  hasActiveQuery = true,
}: {
  hasActiveQuery?: boolean;
}) => {
  return (
    <EmptyState
      title="No instructors found"
      message={
        <Text variant="secondary" fontSize="sm" textAlign="center">
          {hasActiveQuery
            ? "Try a different name or clear the location filter."
            : "No instructors match your current view."}
        </Text>
      }
    />
  );
};
